export default {
  light: '4px',
  rounded: '18px',
  round: '99999px',
}
